import { render, staticRenderFns } from "./ReportAccidentList.vue?vue&type=template&id=3e910f72&scoped=true"
import script from "./ReportAccidentList.vue?vue&type=script&lang=js"
export * from "./ReportAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e910f72",
  null
  
)

export default component.exports